import type { IALMResource, IALMResourceData } from '@/entities';
import { ALMResourceContentTypes } from '@/entities';

export class ALMResource implements IALMResource {
  id = '';
  name = '';
  contentType = ALMResourceContentTypes.Other;
  contentZipUrl?: string | undefined;
  contentTypeData = '';

  constructor(data: IALMResourceData) {
    Object.assign(this, data);
  }
}
